// GTM is now our base analytics
const loadGtm = (w, d, s, l, i) => {
	// eslint-disable-next-line no-param-reassign
	w[l] = w[l] || [];
	w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
	const f = d.getElementsByTagName(s)[0];
	const j = d.createElement(s);
	const dl = l !== 'dataLayer' ? `&l=${l}` : '';
	j.defer = true;
	j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
	f.parentNode.insertBefore(j, f);

	const s2 = d.createElement('script');
	s2.text = `
			window.dataLayer = window.dataLayer || [];
			function gtag() {
				window.dataLayer.push(arguments);
			}
		`;
	f.parentNode.insertBefore(s2, f);
	const { gtag } = w;
	gtag('config', i);
	gtag('js', new Date());
};

export default loadGtm;
